import React from "react";
// import withStyles from "@material-ui/core/styles/withStyles";

import { Dashboard as DashboardLayout } from "../../layouts/";

class Users extends React.Component {
  render() {
    return (
      <DashboardLayout title="Interact and Use">
        <div>
          <h1>Interact and Use</h1>
        </div>
      </DashboardLayout>
    );
  }
}

export default Users;
